const roles = [
  {
    icon: 'ri-user-add-line',
    title: 'Новый сотрудник',
    focus: ['освоение роли', 'необходимые знания', 'стандарты работы', 'практика', 'обратная связь'],
    linkLabel: 'Связано с адаптацией сотрудников',
    linkTo: '/enciklopediya-korporativnogo-obucheniya/adaptaciya-sotrudnikov',
  },
  {
    icon: 'ri-user-settings-line',
    title: 'Специалист',
    focus: ['профессиональные компетенции', 'самостоятельность', 'качество работы', 'дополнительные зоны ответственности'],
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Потенциальный руководитель',
    focus: ['лидерство', 'постановка задач', 'делегирование', 'обратная связь', 'управление конфликтами', 'принятие решений'],
    linkLabel: 'Связано с менеджментом и лидерством',
    linkTo: '/menedzhment-i-liderstvo',
  },
  {
    icon: 'ri-team-line',
    title: 'Руководитель',
    focus: ['эффективность команды', 'управление людьми', 'стратегическое мышление', 'коммуникации', 'развитие сотрудников', 'управление изменениями'],
  },
  {
    icon: 'ri-award-line',
    title: 'Сотрудник кадрового резерва',
    focus: ['компетенции будущей должности', 'развивающие проекты', 'наставничество', 'управленческая практика', 'подготовка к переходу на новую роль'],
  },
];

export default function IPRForDifferentRoles() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          ИПР для разных сотрудников
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Индивидуальный план должен учитывать роль человека
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {roles.map((r, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors flex flex-col">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${r.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{r.title}</h3>
              <div className="flex flex-wrap gap-2 mb-4">
                {r.focus.map((f) => (
                  <span key={f} className="bg-white border border-gray-200 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
                    {f}
                  </span>
                ))}
              </div>
              {r.linkLabel && r.linkTo && (
                <a href={r.linkTo} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto">
                  {r.linkLabel}
                  <i className="ri-arrow-right-line"></i>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}